import { acitivityLogsSlice } from '@Store/slices/activityLogs';

export const { setStartDate, setEndDate, setRole, setUser, clearFilterState } =
  acitivityLogsSlice.actions;
